import Container from 'typedi';
import {
    FeatureAvailabilityToken,
    GTMDataLayerToken,
    LibraryManagerToken,
    UCFData,
    UserContextToken,
} from '../../../../../injection-tokens';
import { FeatureAvailability } from '../../../../feature/feature-availability/feature-availability';
import { UserContext } from '../../../../user-context';

export const setClientServices = () => {
    try {
        Container.set(GTMDataLayerToken, window.dataLayer);
        Container.set(UCFData, window.unifiedClientDataProvider);
        const userContext = new UserContext();
        Container.set(UserContextToken, userContext);
        Container.set(FeatureAvailabilityToken, new FeatureAvailability());
        Container.set(LibraryManagerToken, window.libraryManager);
        // Shift-left: start auth/token retrieval now so it is in-flight before getUserMode awaits it.
        void userContext.initialize();
    } catch (err) {
        console.error('setClientServices failed');
    }
};
